const STORAGE_KEY = 'postLoginReturnTo';
const RETURN_KEYS = ['hat', 'eventID', 'open', 'hostID'];

export function sanitizeReturnTo(value) {
    if (!value || typeof value !== 'string') return '';
    if (!value.startsWith('/') || value.startsWith('//')) return '';
    return value;
}

export function rememberPostLoginReturn(path) {
    const safe = sanitizeReturnTo(path);
    if (!safe) return;
    try {
        sessionStorage.setItem(STORAGE_KEY, safe);
    } catch (_) {}
}

export function clearPostLoginReturn() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
}

function peekPostLoginReturn() {
    try {
        return sanitizeReturnTo(sessionStorage.getItem(STORAGE_KEY));
    } catch (_) {
        return '';
    }
}

export function returnToFromSearch(search) {
    const params = new URLSearchParams(search || '');
    const next = new URLSearchParams();
    RETURN_KEYS.forEach((key) => {
        const value = params.get(key);
        if (value) next.set(key, value);
    });
    const qs = next.toString();
    return qs ? `/dashboard?${qs}` : '';
}

export function destinationAfterLogin(location) {
    const fromQuery = returnToFromSearch(location && location.search);
    const fromState = sanitizeReturnTo(
        location && location.state && location.state.from
    );
    const stored = peekPostLoginReturn();
    return fromQuery || fromState || stored || '/dashboard';
}
